export default {
    "0": {
        "RAN": 72,
        "Word Manipulation": 72,
        "Nonsense Word Repetition": 72,
        "Letter Sounds": 72,
        "Word Reading": 72,
        "Blending": 72,
        "NWF": 65,
        "Spelling": 224,
        "Vocabulary": 74,
        "Listening Comprehension": 453.9,
        "Oral Reading Fluency": 70,
        "Reading Comprehension": 45,
        "Letter Naming And Sounds": 271,
    },
    "1": {
        "RAN": 69,
        "Word Manipulation": 69,
        "Nonsense Word Repetition": 69,
        "Letter Sounds": 69,
        "Word Reading": 69,
        "Blending": 69,
        "NWF": 79,
        "Spelling": 258,
        "Vocabulary": 64,
        "Listening Comprehension": 139,
        "Oral Reading Fluency": 216,
        "Reading Comprehension": 65,
        "Letter Naming And Sounds": 243,
    },
    "2": {
        "RAN": 69,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 69,
        "Blending": 0,
        "NWF": 87,
        "Spelling": 273,
        "Vocabulary": 55,
        "Listening Comprehension": 155,
        "Oral Reading Fluency": 192,
        "Reading Comprehension": 79,
        "Letter Naming And Sounds": 92,
    },
    "3": {
        "RAN": 65,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 65,
        "Blending": 0,
        "NWF": 65,
        "Spelling": 254,
        "Vocabulary": 68,
        "Listening Comprehension": 201,
        "Oral Reading Fluency": 239,
        "Reading Comprehension": 76,
        "Letter Naming And Sounds": 93,
    },
    "4": {
        "RAN": 64,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 64,
        "Blending": 0,
        "NWF": 66,
        "Spelling": 196,
        "Vocabulary": 59,
        "Listening Comprehension": 176,
        "Oral Reading Fluency": 188,
        "Reading Comprehension": 45,
        "Letter Naming And Sounds": 102,
    },
    "5": {
        "RAN": 65,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 65,
        "Blending": 0,
        "NWF": 57,
        "Spelling": 181,
        "Vocabulary": 64,
        "Listening Comprehension": 154,
        "Oral Reading Fluency": 214,
        "Reading Comprehension": 38,
        "Letter Naming And Sounds": 93,
    },
    "6": {
        "RAN": 64,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 64,
        "Blending": 0,
        "NWF": 56,
        "Spelling": 170,
        "Vocabulary": 58,
        "Listening Comprehension": 146,
        "Oral Reading Fluency": 240,
        "Reading Comprehension": 39,
        "Letter Naming And Sounds": 104,
    }
}
